import React from 'react';
export function Problem() {
  return <section id="problema" className="py-10 bg-white" data-id="element-207">
      <div className="container mx-auto px-4" data-id="element-208">
        <div className="max-w-3xl mx-auto text-center mb-10" data-id="element-209">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4" data-id="element-210">
            El Verdadero Problema
          </h2>
          <p className="text-xl text-gray-600" data-id="element-211">
            Muchos padres hispanos en EE.UU. sueñan con un futuro bilingüe para
            sus hijos. Pero al intentarlo, surgen miedos...
          </p>
        </div>
        <div className="grid md:grid-cols-2 gap-8 mb-8" data-id="element-212">
          <div className="bg-orange-50 p-8 rounded-lg shadow-md" data-id="element-213">
            <h3 className="text-xl font-semibold text-gray-800 mb-4" data-id="element-214">
              Los Mitos
            </h3>
            <ul className="space-y-3" data-id="element-215">
              <li className="flex items-start" data-id="element-216">
                <svg className="h-6 w-6 text-orange-500 mr-2 mt-1 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-217">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z" data-id="element-218" />
                </svg>
                <span data-id="element-219">"Si le hablo en dos idiomas... ¿se va a confundir?"</span>
              </li>
              <li className="flex items-start" data-id="element-220">
                <svg className="h-6 w-6 text-orange-500 mr-2 mt-1 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-221">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z" data-id="element-222" />
                </svg>
                <span data-id="element-223">"¿Y si se retrasa en el habla?"</span>
              </li>
              <li className="flex items-start" data-id="element-224">
                <svg className="h-6 w-6 text-orange-500 mr-2 mt-1 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-225">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z" data-id="element-226" />
                </svg>
                <span data-id="element-227">"¿Y si mezcla todo y no domina ninguno?"</span>
              </li>
            </ul>
            <div className="mt-6 text-gray-700" data-id="element-228">
              <p className="font-bold text-orange-600" data-id="element-229">
                La verdad: esos son mitos.
              </p>
              <p className="mt-2" data-id="element-230">
                Estudios de Harvard y Stanford confirman que los niños criados
                en entornos bilingües desarrollan:
              </p>
              <ul className="mt-3 space-y-2" data-id="element-231">
                <li className="flex items-start" data-id="element-232">
                  <svg className="h-5 w-5 text-green-500 mr-2 mt-1 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-233">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" data-id="element-234" />
                  </svg>
                  <span data-id="element-235">Mayor capacidad cognitiva</span>
                </li>
                <li className="flex items-start" data-id="element-236">
                  <svg className="h-5 w-5 text-green-500 mr-2 mt-1 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-237">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" data-id="element-238" />
                  </svg>
                  <span data-id="element-239">Mejor desempeño escolar</span>
                </li>
                <li className="flex items-start" data-id="element-240">
                  <svg className="h-5 w-5 text-green-500 mr-2 mt-1 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-241">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" data-id="element-242" />
                  </svg>
                  <span data-id="element-243">Más oportunidades profesionales en el futuro</span>
                </li>
              </ul>
            </div>
          </div>
          <div className="bg-orange-50 p-8 rounded-lg shadow-md" data-id="element-244">
            <h3 className="text-xl font-semibold text-gray-800 mb-4" data-id="element-245">
              El Enemigo Real
            </h3>
            <p className="text-gray-700 mb-4" data-id="element-246">
              No es que el bilingüismo confunda. El verdadero enemigo... es la
              falta de intención en casa.
            </p>
            <p className="text-gray-700 mb-4" data-id="element-247">
              Cuando se deja todo en manos de la escuela, el inglés termina
              dominando... y el español se desvanece.
            </p>
            <p className="text-gray-700 mb-4 font-medium" data-id="element-248">
              Y con él se pierde:
            </p>
            <ul className="space-y-3 mb-6" data-id="element-249">
              <li className="flex items-start" data-id="element-250">
                <svg className="h-5 w-5 text-red-500 mr-2 mt-1 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-251">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M18 12H6" data-id="element-252" />
                </svg>
                <span data-id="element-253">La conexión con los abuelos</span>
              </li>
              <li className="flex items-start" data-id="element-254">
                <svg className="h-5 w-5 text-red-500 mr-2 mt-1 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-255">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M18 12H6" data-id="element-256" />
                </svg>
                <span data-id="element-257">El hilo cultural de la familia</span>
              </li>
              <li className="flex items-start" data-id="element-258">
                <svg className="h-5 w-5 text-red-500 mr-2 mt-1 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-259">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M18 12H6" data-id="element-260" />
                </svg>
                <span data-id="element-261">
                  Ventajas académicas y laborales que solo el bilingüismo
                  completo puede dar
                </span>
              </li>
            </ul>
            <h4 className="font-semibold text-gray-800 mt-6 mb-3" data-id="element-262">
              Lo que los padres suelen intentar (y por qué no funciona):
            </h4>
            <ul className="space-y-3" data-id="element-263">
              <li className="flex items-start" data-id="element-264">
                <svg className="h-5 w-5 text-orange-500 mr-2 mt-1 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-265">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" data-id="element-266" />
                </svg>
                <span data-id="element-267">
                  Confiar solo en la escuela: el inglés gana terreno y el
                  español desaparece
                </span>
              </li>
              <li className="flex items-start" data-id="element-268">
                <svg className="h-5 w-5 text-orange-500 mr-2 mt-1 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-269">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" data-id="element-270" />
                </svg>
                <span data-id="element-271">
                  Esperar que "solito" aprenda: los niños no practican y el
                  idioma se enfría
                </span>
              </li>
              <li className="flex items-start" data-id="element-272">
                <svg className="h-5 w-5 text-orange-500 mr-2 mt-1 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-273">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" data-id="element-274" />
                </svg>
                <span data-id="element-275">
                  Hablar solo español en casa sin estrategia: se siente como una
                  obligación, y nace la resistencia
                </span>
              </li>
            </ul>
            <div className="mt-6 bg-orange-100 p-4 rounded-md" data-id="element-276">
              <p className="font-semibold text-orange-800" data-id="element-277">¿Resultado?</p>
              <p className="text-orange-800" data-id="element-278">
                Niños que entienden español... pero no lo hablan. Y con el
                tiempo, ni siquiera lo entienden.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}